export default __webpack_public_path__ + "5e6e90df24ff9d5126bc55c0c7f62c88.svg";